import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container } from 'reactstrap'
import { isEmpty, isEqual } from 'lodash'
import { sprintf } from 'sprintf-js'
import gsap from 'gsap'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Icon from 'generics/Icon'

import { ACTIONS, I18N, USER } from 'constants/props'
import { COLORS } from 'constants/colors'
import * as notificationsActions from 'app_modules/notifications/actions'
import * as sessionSelectors from 'app_modules/session/selectors'
import currentNotification from 'app_modules/notifications/selectors'
import Translation from 'generics/Translation'

import styles from './notifications.scss'

export class notifications extends Component {
  constructor(props) {
    super(props)
    this.state = {
      delay: 15,
    }
  }

  componentDidMount() {
    const { actions, notification } = this.props

    const { delay } = this.state
    this.tl = gsap.timeline({ paused: true })
    this.tween2 = gsap.to(this.notifications, {
      delay,
      duration: 0.5,
      ease: 'Expo.easeOut',
      onComplete: () => {
        actions.clearBarNotification()
      },
      opacity: 0,
      top: '100%',
    })
    this.tl
      .add(
        gsap.to(this.notifications, {
          duration: 0.6,
          ease: 'Expo.easeOut',
          opacity: 1,
          top: '100%',
        }),
        'init',
      )
      .add(this.tween2)

    if (Object.keys(notification).length) {
      this.tl.play('init')
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { options } = nextProps.notification
    const { notification } = this.props
    if (!isEmpty(options) && options.delay) {
      this.setState({
        ...options,
        delay: options.delay || 15,
      })
    }
    if (isEmpty(nextProps.notification)) {
      this.handleClose()
    } else if (!isEmpty(nextProps.notification) && !isEqual(notification, nextProps.notification)) {
      this.tl.restart()
    }
  }

  shouldComponentUpdate(nextProps) {
    return Object.keys(nextProps.notification).length
  }

  // eslint-disable-next-line camelcase
  // UNSAFE_componentWillUpdate() {
  //   this.tl.restart()
  // }

  componentWillUnmount() {
    this.tl.kill()
  }

  handleIsPersistent = options => {
    if (!isEmpty(options) && options.persistent) {
      this.tl.remove(this.tween2)
    } else {
      try {
        this.tl.remove(this.tween2)
        // eslint-disable-next-line no-empty
      } catch (e) {}
      this.tl.add(this.tween2)
    }
  }

  handleClose = () => {
    this.notifications.style.opacity = 0
  }

  render() {
    const { className, i18n, testAttribute, notification, user } = this.props

    const { label, message, title } = notification

    const options = {
      type: 'success',
      ...notification.options,
    }

    const { type } = options

    const notificationMessage = (label && i18n.notifications[label]) || message

    return (
      <div>
        <div
          ref={element => {
            this.notifications = element
          }}
          className={classnames(
            styles.notifications,
            styles[type],
            { [styles['has-content']]: title || label || message },
            className,
          )}
        >
          <Container>
            {title && (
              <span className={styles.title} title={title}>
                {title}
              </span>
            )}
            {notificationMessage && (
              <span className={styles.message} data-test={testAttribute} title={notificationMessage}>
                {notificationMessage}
              </span>
            )}
            {options?.btnAction ? <options.btnAction /> : null}
            {options?.showClose && (
              <Icon.Stroke7
                name="close"
                className={styles.crossIcon}
                onClick={() => {
                  this.handleClose()
                  if (notification.options?.onClose) {
                    notification.options.onClose()
                  }
                }}
                stroke={COLORS.grey1.rgba}
              />
            )}
          </Container>
        </div>

        {user && user.impersonateToken && (
          <div
            className={classnames(
              styles.notifications__impersonate,
              styles[type],
              { [styles['has-content']]: true },
              className,
            )}
          >
            <Container>
              {user.internalAdmin.name && (
                <span className={styles.title} title={user.internalAdmin.name}>
                  {sprintf(i18n.notifications.isImpersonatingTo, { internalAdminName: user.internalAdmin.name })}
                </span>
              )}
              <span className={styles.message} title={user.currentProfile.firstName}>
                {`${user.currentProfile.firstName} ${user.currentProfile.lastName}`}
              </span>
            </Container>
          </div>
        )}
      </div>
    )
  }
}

notifications.propTypes = {
  actions: ACTIONS.isRequired,
  className: PropTypes.string,
  testAttribute: PropTypes.string,
  i18n: I18N.isRequired,
  notification: PropTypes.shape({
    label: PropTypes.string,
    message: PropTypes.string,
    options: PropTypes.shape({
      delay: PropTypes.number,
      persistent: PropTypes.bool,
      onClose: PropTypes.func,
    }),
    title: PropTypes.string,
  }),
  user: USER,
}

notifications.defaultProps = {
  className: null,
  testAttribute: null,
  notification: {
    title: '',
    message: '',
    options: {},
  },
  user: null,
}

const mapStateToProps = state => ({
  notification: currentNotification(state),
  user: sessionSelectors.user(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(notificationsActions, dispatch),
})

export default Translation(connect(mapStateToProps, mapDispatchToProps)(notifications), ['notifications'])
